import React from 'react';
import {
  CustomInputContainer,
  CustomSelectWrapper,
  CustomInputLabel,
  ErrorMessage,
} from './CustomInputs.styles';
import { useTheme } from '../../../../context/PermissionsContext/ThemeContext/ThemeContext';

interface Props {
  label: string;
  value: any;
  onChange: (newValue: any) => void;
  items: { label: string; value: any }[];
  error?: boolean;
  errorMessage?: string;
  placeholder?: string;
  allowEmptyValue?: boolean;
}

const CustomSelect: React.FC<Props> = ({
  onChange,
  value,
  items,
  label,
  error = false,
  errorMessage = '',
  placeholder = 'Select',
  allowEmptyValue = false,
}) => {
  const { theme } = useTheme();
  const placeholderValue = allowEmptyValue ? '__placeholder__' : '';
  const resolvedValue =
    value === undefined || value === null ? placeholderValue : value;
  return (
    <CustomInputContainer>
      <CustomInputLabel style={{ color: theme.text }}>{label}</CustomInputLabel>
      <CustomSelectWrapper
        style={{
          color: theme.text,
          borderColor: error ? '#FF5C77' : theme.stroke,
        }}
        value={resolvedValue}
        onChange={(e) => {
          const newValue = e.target.value;
          if (allowEmptyValue && newValue === '__placeholder__') {
            onChange('');
          } else {
            onChange(newValue);
          }
        }}
      >
        <option value={placeholderValue} disabled>
          {placeholder}
        </option>
        {items.map((item) => {
          return (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </CustomSelectWrapper>
      {error && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </CustomInputContainer>
  );
};

export default CustomSelect;
